import React, { useId, useMemo } from "react";
import ".././PopupCommonStyle.css";
import styles from "./Style.module.css";
import { buildServiceBreakdownRows, buildVoucherBreakdownRows } from "../../../Utils/priceBreakdown";

import { BtnSecondary } from "../../Buttons/BtnSecondary";

export { buildServiceBreakdownRows, buildVoucherBreakdownRows } from "../../../Utils/priceBreakdown";

const formatCurrency = (value) => `S$${(Number(value) || 0).toFixed(2)}`;
const formatStartingPrice = (value) => `From ${formatCurrency(value)}+`;

export const PriceBreakdownPopup = ({
  active,
  onClose,
  selectedServices,
  selectedVouchers,
  displayTotal,
  isVoucher = false,
}) => {
  const titleId = useId();
  const serviceRows = useMemo(
    () => buildServiceBreakdownRows(selectedServices),
    [selectedServices]
  );
  const voucherRows = useMemo(
    () => buildVoucherBreakdownRows(selectedVouchers),
    [selectedVouchers]
  );
  const voucherTotal = useMemo(
    () => voucherRows.reduce((total, row) => total + row.lineTotal, 0),
    [voucherRows]
  );

  return (
    <div
      className={`${styles.priceBreakdownPopup} popup ${active ? "show" : ""}`}
      role="dialog"
      aria-modal={active ? "true" : undefined}
      aria-hidden={!active}
      aria-labelledby={titleId}
    >
      <div className={`${styles.popHeader} popup-header`}>
        <h2 id={titleId} className="title">Price Breakdown</h2>
        {/* <BtnClose
          handleClick={onClose}
          title="Close price breakdown"
          customClass={styles.closeBtn}
        /> */}
      </div>

      <div className={`${styles.priceBreakdownContent} popup-body`}>
          {isVoucher ? (
            voucherRows.length > 0 ? (
              <>
              <div
                className={`${styles.priceBreakdownList} ${styles.serviceBreakdownList}`}
                role="list"
              >
                {voucherRows.map((voucher, voucherIndex) => (
                  <React.Fragment key={voucher.key}>
                    <div
                      className={`${styles.priceBreakdownItem} ${styles.serviceItem}`}
                      role="listitem"
                    >
                      <div className={styles.priceBreakdownItemLeft}>
                        {voucher.quantity}x {voucher.name}
                      </div>
                      <div className={styles.priceBreakdownItemRight}>
                        {formatCurrency(voucher.lineTotal)}
                      </div>
                    </div>

                    {voucherIndex < voucherRows.length - 1 && (
                      <div className={styles.divider} />
                    )}
                  </React.Fragment>
                ))}
              </div>

              <div className={styles.priceBreakdownTotal}>
                <div className={styles.priceBreakdownItem}>
                  <div
                    className={`${styles.priceBreakdownItemLeft} ${styles.boldText}`}
                  >
                    Total
                  </div>
                  <div
                    className={`${styles.priceBreakdownItemRight} ${styles.boldText}`}
                  >
                    {formatCurrency(voucherTotal)}
                  </div>
                </div>
              </div>
            </>
            ) : (
              <p className={styles.priceBreakdownEmpty}>No vouchers selected</p>
            )
          ) : serviceRows.length > 0 ? (
            <>
            <div
              className={`${styles.priceBreakdownList} ${styles.serviceBreakdownList}`}
              role="list"
            >
              {serviceRows.map((service, serviceIndex) => (
                <React.Fragment
                  key={service.key}
                >
                  <div
                    className={`${styles.priceBreakdownItem} ${styles.serviceItem}`}
                    role="listitem"
                  >
                    <div className={styles.priceBreakdownItemLeft}>
                      {service.quantity > 1 ? `${service.quantity}x ` : ''}{service.duration} Mins {service.name}
                    </div>
                    <div className={styles.priceBreakdownItemRight}>
                      {formatStartingPrice(
                        service.lineTotal
                      )}
                    </div>
                  </div>

                  {service.selectedAddons.map((addon) => (
                    <div
                      className={`${styles.priceBreakdownItem} ${styles.addonItem}`}
                      key={addon.key}
                      role="listitem"
                    >
                      <div className={styles.priceBreakdownItemLeft}>
                        {addon.quantity > 1 ? `${addon.quantity}x ` : ''}{addon.name}
                      </div>
                      <div className={styles.priceBreakdownItemRight}>
                        {formatStartingPrice(
                          addon.lineTotal
                        )}
                      </div>
                    </div>
                  ))}

                  {serviceIndex < serviceRows.length - 1 && (
                    <div className={styles.divider} />
                  )}

                </React.Fragment>
              ))}
            </div>

            <div className={styles.priceBreakdownTotal}>
              <div className={styles.priceBreakdownItem}>
                <div
                  className={`${styles.priceBreakdownItemLeft} ${styles.boldText}`}
                >
                  Total
                </div>
                <div
                  className={`${styles.priceBreakdownItemRight} ${styles.boldText}`}
                >
                  {formatStartingPrice(displayTotal)}
                </div>
              </div>
            </div>
            </>
          ) : (
            <p className={styles.priceBreakdownEmpty}>No services selected</p>
          )}
        </div>

      <div className={`${styles.footer} popup-footer`}>
        <BtnSecondary
          type="button"
          label="Close"
          handleClick={onClose}
          customClass="w-100"
        />
      </div>
    </div>
  );
};
